import * as z from "zod";

export const SUFFIX_OPTIONS = ["Jr.", "Sr.", "II", "III", "IV", "V"] as const;

export const LODGE_OPTIONS = [
  "Non-Mason / Community Supporter",
  "Abiff Lodge No. 21",
  "Acacia Lodge No. 39",
  "Capitol Lodge No. 8",
  "Central Lodge No. 10",
  "Central Star Lodge No. 23",
  "Composite Lodge No. 17",
  "Doric Lodge No. 22",
  "Eureka Lodge No. 16",
  "Famabiff Lodge No. 33",
  "Geometry Lodge No. 49",
  "Gibraltar Lodge No. 19",
  "Golden Rule Lodge No. 36",
  "H. York Harrison Lodge No. 32",
  "Hiram Lodge No. 1",
  "Jimmie Lunceford Lodge No. 45",
  "John W. Stevenson Lodge No. 56",
  "King David Lodge No. 20",
  "Mount Pavan Lodge No. 2",
  "North Star Lodge No. 5",
  "Peter Salem Lodge No. 40",
  "Prince Hall Lodge No. 24",
  "Pythagoras Lodge No. 14",
  "Redeemer Lodge No. 53",
  "St. Andrews Lodge No. 7",
  "St. Mary's Lodge No. 4",
  "St Johns Lodge No. 44",
  "Travelers Lodge No. 46",
  "Tyre Lodge No. 34",
  "Unity Lodge No. 28",
  "Waterford Lodge No. 31",
  "Wisdom Lodge No. 57",
  "Lodge Not Listed",
] as const;

export const donorSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  middleName: z.string().optional(),
  lastName: z.string().min(1, "Last name is required"),
  suffix: z.string().optional(),
  email: z.string().email("Please enter a valid email address"),
  lodge: z.string().min(1, "Please select your lodge"),
  tierId: z.enum(["monthly", "annual", "onetime-year", "champion"]),
});

export type DonorFormData = z.infer<typeof donorSchema>;

// Lighter-weight schema for the general donation modal (no lodge / no tier).
// Organization is optional so non-affiliated individual donors aren't blocked.
export const generalDonorSchema = z.object({
  fullName: z.string().min(1, "Name is required"),
  email: z.string().email("Please enter a valid email address"),
  organization: z.string().optional(),
});

export type GeneralDonorFormData = z.infer<typeof generalDonorSchema>;
